import { z } from 'zod';
import { SignalGroupMemberTypes } from 'applications/signal/constants';

const memberTypeOrdinals = Object.values(SignalGroupMemberTypes).map(
  (v) => v.ordinal
);

export const GroupMemberAddModalSchema = z.object({
  email: z.string().email("有効なメールアドレスを入力してください"),
  memberType: z.union(
    memberTypeOrdinals.map(n => z.literal(n)) as unknown as [z.ZodLiteral<number>, z.ZodLiteral<number>]
  ),
});

export type GroupMemberAddModalData = z.infer<typeof GroupMemberAddModalSchema>;
